export default "__VITE_ASSET__Cx348AHj__"